import React from 'react';

const NoSummaryFound = () => {
  return (
    <div className="flex flex-col items-center justify-center border-0">
      <h3 className="text-base font-semibold text-gray-blue-70">
        No summary found
      </h3>
    </div>
  );
};

export default NoSummaryFound;
